import React, { useState } from "react";
export default function TextForm(props) {
  //For Upper Case
  const handleUpClick = () => {
    // console.log("Uppercase was clicked"+ text);
    let newText = text.toUpperCase();
    setText(newText);
props.showAlert("Converted to UpperCase!","success");
  };
  //For Lower Case
  const handleLoClick = () => {
    let newText = text.toLowerCase();
    setText(newText);
    props.showAlert("Converted to LowerCase!","success");

  };
  //For Clear Text
  const handleClearClick = () => {
    let newText = "";
    setText(newText);
    props.showAlert("Text has been Cleared!","success");

  };
  //For Speak text
  const [speaking,setSpeaking]=useState(false);
  const speak = () => {
if(!speaking){
    let newText = new SpeechSynthesisUtterance(text);
    newText.text = text;
    window.speechSynthesis.speak(newText);
    setSpeaking(true);
    }else{
        window.speechSynthesis.cancel();
        setSpeaking(false);
    }
    props.showAlert("Speak mode is Activated!","success");
   
  };
  //For Sentence First letter Capital Case
  const handleSentenceUpClick = () => {
    // Convert the text to lower case
    let lowerCase = text.toLowerCase();

    // Regular expression to match sentences while keeping line breaks intact
    let regex = /([^\n.!?]*[.!?]*\n?)/g;

    // Match the sentences using the regex
    let sentences = lowerCase.match(regex);

    // If sentences are found, process them
    if (sentences) {
        let newText = sentences.map((sentence) => {
            sentence = sentence.trimStart(); // Remove leading spaces, but keep new lines
            return sentence.charAt(0).toUpperCase() + sentence.slice(1);
        }).join("");
        setText(newText);
    } else {
        // If no matches, set the text as is
        setText(text);
    }

    props.showAlert("Converted into Sentence Case!", "success");
};




    //For Word First letter Capital Case
  const handleWordUpClick = () => {
    let lowercase = text.toLowerCase();
    
    // Use a regular expression to find words while preserving spaces and new lines
    let newText = lowercase.replace(/(\S)(\S*)/g, (match, firstLetter, restOfWord) => {
      return firstLetter.toUpperCase() + restOfWord;
    });
    setText(newText);
    props.showAlert("Converted into WordCase!","success");

  };
   //For Copy Into ClipBoard
   const handleCopy = () => {

    navigator.clipboard.writeText(text);
    props.showAlert("Copied into Clipboard!","success");

     };
 //For Remove Extra Spaces
 const handleExtraSpaces = () => {
    let newText= text.split(/[ ]+/);
    setText(newText.join(" "));
    props.showAlert("Extra Spaces Removed!","success");

     };

  //Handle Change
  const handleUpChange = (event) => {
    // console.log("On Change");
    setText(event.target.value);
  };
  const [text, setText] = useState("");
  return (
    <>
      <div className="container " style={{color: props.mode==='dark'?'white':'black'}}>
        <h1 >{props.heading}</h1>
        <div className="mb-3">
          <textarea className="form-control " value={text} style={{backgroundColor: props.mode==='dark'?'black':'white',color: props.mode==='dark'?'white':'black'}} onChange={handleUpChange} id="myBox"  rows="8" ></textarea>
        </div>
        {/* Buttons */}
        <button disabled={text.length===0}  className="btn btn-primary mx-2 my-3" onClick={handleUpClick}>
          Convert To Upper Case
        </button>
        <button disabled={text.length===0}  className="btn btn-primary mx-2 my-3" onClick={handleLoClick}>
          Convert To Lower Case
        </button>
        <button disabled={text.length===0} className="btn btn-primary mx-2 my-3" onClick={handleClearClick}>
          Clear Text
        </button>
        <button disabled={text.length===0}  className="btn btn-primary mx-2 my-3" onClick={speak}>
        {speaking?'Stop':'Speak'}
        </button>
        <button disabled={text.length===0}  className="btn btn-primary mx-2" onClick={handleSentenceUpClick}>
          Sentence Case
        </button>
        <button disabled={text.length===0}  className="btn btn-primary mx-2 my-3" onClick={handleWordUpClick}>
          Word Case
        </button>

        <button disabled={text.length===0}  className="btn btn-primary mx-2 my-3" onClick={handleCopy}>
         Copy Text
        </button>

        <button disabled={text.length===0}  className="btn btn-primary mx-2 my-3" onClick={handleExtraSpaces}>
         Remove Extra Spaces
        </button>
      </div>
      <div className="container my-3"  style={{color: props.mode==='dark'?'white':'black'}}>
        <h2>Your Text Summary</h2>
        <p>
          {text.split(/\s+/).filter((element)=>{return element.length!==0}).length} words and {text.length} characters{" "}
        </p>
        <p>{0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length} Minutes read</p>
        <h2>Preview</h2>
        <p>{text.length>0?text:"Nothing to Preview..."}</p>
      </div>
    </>
  );
}